<template>
    <el-form :model="deviceMaintPlan" ref="voucherInfo">
        <div class="content-caption dashed">
            <span>基础信息</span>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">标题</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="title" :rules="{validator: checkNull, trigger: 'blur'}">
                        <el-input type="text" v-model="deviceMaintPlan.title" placeholder="请输入标题"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">周期保养</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="cronFlag">
                        <el-radio-group v-model="deviceMaintPlan.cronFlag" @change="checkInfo">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center" v-if="!deviceMaintPlan.cronFlag">
                <div class="form-label">
                    <label class="required">保养时间</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="theDateTime" :rules="{validator: checkTheDateTime, trigger: 'blur'}">
                        <el-date-picker v-model="deviceMaintPlan.theDateTime" type="datetime" :picker-options="pickerOptions0" placeholder="选择日期时间" format="yyyy-MM-dd HH:mm"></el-date-picker>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center" v-if="deviceMaintPlan.cronFlag">
                <div class="form-label">
                    <label class="required">保养时间</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="theExprDesc" :rules="{validator: checkNull, trigger: 'blur'}">
                        <span>{{deviceMaintPlan.theExprDesc || ''}}</span>
                        <a class="swb-btn-link" @click="selectCronInfo">选择周期</a>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center" v-if="deviceMaintPlan.cronFlag">
                <div class="form-label">
                    <label>保养截止时间</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="limitEndTime" :rules="{validator: checkNone, trigger: 'blur'}">
                        <span>{{deviceMaintPlan.limitEndTime || "无"}}</span>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">保养范围</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item>
                        <el-radio-group v-model="deviceMaintPlan.suitFlag" @change="suitFlagChange">
                            <el-radio :label="false">标准资产</el-radio>
                            <el-radio :label="true">套装资产</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>保养资产</span>
        </div>
        <div class="hint block">
            <div class="title">温馨提示</div>
            <p>1、线上采购且在保内的商品是约定期保内，其他情况均为约定期保外</p>
            <p>2、根据选定的页签选择的资产会自动过滤约定期保内、约定期保外</p>
        </div>
        <div class="simple-row">
            <div class="left">
                <a class="swb-btn swb-btn-small" @click="selectDevice()">选择资产</a>
                <a class="swb-btn swb-btn-small" @click="setYqInfo(deviceMaintPlan.cronFlag, deviceMaintPlan.theDateTime)" v-if="deviceMaintPlan.deviceSubNoWrntList != null && deviceMaintPlan.deviceSubNoWrntList.length > 0 || (deviceMaintPlan.deviceSubNoCatList != null && deviceMaintPlan.deviceSubNoCatList.length > 0)">设置工单截止要求</a>
            </div>
            <div class="right">
                <span>共{{selectCount}}条</span>
            </div>
        </div>
        <div class="tab-container small base pos-rel">
            <div class="tabs-nav">
                <ul class="head">
                    <li :class="{'current': status.value == checkStateValue}" class="head-item" v-for="status in tableState" @click="handleTabClick(status.value)">
                        <span>{{status.text}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 保内 -->
        <div class="table-layout" style="overflow-x: auto" v-if="checkStateValue == 0">
            <table class="custom-tbl error-prompt">
                <thead class="head">
                <tr class="row">
                    <th style="text-align: left; width: 155px;">资产名称</th>
                    <th style="text-align: left; width: 155px;" v-if="deviceMaintPlan.suitFlag">套装名称</th>
                    <th style="text-align: left; width: 240px;">系统编号</th>
                    <th style="width: 155px;">质保到期时间</th>
                    <th style="text-align: left; width: 200px;">供应商名称</th>
                    <th style="text-align: left; width: 200px;">服务商名称</th>
                    <th style="text-align: left; width: 150px;">基于合同</th>
                    <th style="text-align: left; width: 150px;" class="required">服务名称</th>
                    <th style="text-align: center; width: 242px;" v-if="deviceMaintPlan.cronFlag">首次工单截止时间</th>
                    <th style="text-align: center; width: 242px;" v-else="!deviceMaintPlan.cronFlag">工单截止时间</th>
                    <th style="text-align: right; width: 120px;" v-if="deviceMaintPlan.cronFlag">要求完成小时</th>
                    <th style="text-align: right; width: 120px;">提前预警小时</th>
                    <th style="text-align: left; width: 216px;">操作</th>
                </tr>
                </thead>
                <tbody class="body" v-if="deviceMaintPlan.deviceSubNoWrntList != null && deviceMaintPlan.deviceSubNoWrntList.length > 0">
                <tr class="row" v-for="(deviceSubNo, index) in deviceMaintPlan.deviceSubNoWrntList">
                    <td style="text-align: left;" :title="deviceSubNo.title">{{deviceSubNo.title}}</td>
                    <td style="text-align: left;" v-if="deviceMaintPlan.suitFlag" :title="deviceSubNo.suitName || '无'">{{deviceSubNo.suitName || '无'}}</td>
                    <td style="text-align: left;">{{deviceSubNo.tmpNo}}</td>
                    <td>{{deviceSubNo.wrntDueTime}}</td>
                    <td style="text-align: left;">
                        <span :title="roleMerchtVendor(deviceSubNo)">{{ roleMerchtVendor(deviceSubNo) }}</span>
                    </td>
                    <td style="text-align: left;">
                        <span :title="roleMerchtServicer(deviceSubNo)">{{ roleMerchtServicer(deviceSubNo) }}</span>
                    </td>
                    <td>
                        <span v-if="deviceSubNo.contractId != null">是</span>
                        <span v-else>否</span>
                    </td>
                    <td style="text-align: left;" :title="deviceSubNo.servcTitle || '无'">{{deviceSubNo.servcTitle || '无'}}</td>
                    <td style="text-align: center;">
                        <el-form-item>
                            <el-date-picker v-model="deviceSubNo.yqFinishTime" :picker-options="pickerOptions0" type="datetime" placeholder="请选择" @change="yqFinishTimeChange(deviceSubNo)"></el-date-picker>
                        </el-form-item>
                    </td>
                    <td style="text-align: right;" v-if="deviceMaintPlan.cronFlag">
                        <span>{{deviceSubNo.yqFinishHours}}</span>
                    </td>
                    <td style="text-align: right;">
                        <el-form-item :prop="'deviceSubNoWrntList.' + index + '.yqFinishAotHr'" :rules="{validator: inputYqFinishAotHr, trigger: 'blur'}">
                            <el-input type="number" min="0" class="input-content-right" @change="quantityYqFinishAotHr(deviceSubNo);" v-model.number="deviceSubNo.yqFinishAotHr"></el-input>
                        </el-form-item>
                    </td>
                    <td style="text-align: left;">
                        <a class="swb-btn-link" v-if="deviceSubNo.ssuId == null" @click="selectMsu(deviceSubNo)">选择服务</a>
                        <a class="swb-btn-link" v-else @click="removeMsu(deviceSubNo)">移除服务</a>
                        <a class="swb-btn-link" @click="deleteSelectDeviceSubNo(index)">移除</a>
                    </td>
                </tr>
                </tbody>
                <tfoot class="foot" v-else>
                <tr class="row">
                    <td colspan="11" v-if="!deviceMaintPlan.suitFlag">
                        <span>未选择资产</span>
                    </td>
                    <td colspan="12" v-if="deviceMaintPlan.suitFlag">
                        <span>未选择资产</span>
                    </td>
                </tr>
                </tfoot>
            </table>
        </div>
        <!-- 保外 -->
        <div class="table-layout" style="overflow-x: auto" v-else>
            <div class="tab-container small base" v-if="stateValue != null">
                <div class="tabs-nav">
                    <ul class="head">
                        <li :class="{'current': status.value == stateValue}" class="head-item" v-for="status in tableStateForCat" @click="handleCatTabClick(status.value)">
                            <span>{{status.text}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <!--<div v-if="deviceMaintPlan.deviceSubNoCatList != null && deviceMaintPlan.deviceSubNoCatList.length > 0">-->
                <!--<a class="swb-btn swb-btn-small" v-if="deviceMaintPlan.deviceSubNoCatList[0].ssuId == null" @click="selectMsuForAll(deviceMaintPlan.deviceSubNoCatList[0])">选择服务</a>-->
            <!--</div>-->
            <table class="custom-tbl error-prompt mt10">
                <thead class="head">
                <tr class="row">
                    <th style="text-align: left; width: 155px;">资产描述全称</th>
                    <th style="text-align: left; width: 155px;" v-if="deviceMaintPlan.suitFlag">套装名称</th>
                    <th style="text-align: left; width: 240px;">系统编号</th>
                    <th style="width: 155px;">质保到期时间</th>
                    <th style="text-align: left; width: 200px;">供应商名称</th>
                    <th style="text-align: left; width: 200px;" class="required">服务商名称</th>
                    <th style="text-align: left; width: 150px;" class="required">基于合同</th>
                    <th style="text-align: left; width: 150px;" class="required">服务名称</th>
                    <th style="text-align: center; width: 242px;" v-if="deviceMaintPlan.cronFlag">首次工单截止时间</th>
                    <th style="text-align: center; width: 242px;" v-else="!deviceMaintPlan.cronFlag">工单截止时间</th>
                    <th style="text-align: right; width: 120px;" v-if="deviceMaintPlan.cronFlag">要求完成小时</th>
                    <th style="text-align: right; width: 120px;">提前预警小时</th>
                    <th style="text-align: left; width: 216px;">操作</th>
                </tr>
                </thead>
                <tbody class="body" v-if="deviceMaintPlan.deviceSubNoCatList != null && deviceMaintPlan.deviceSubNoCatList.length > 0">
                <tr class="row" v-for="(deviceSubNo, index) in deviceMaintPlan.deviceSubNoCatList">
                    <td style="text-align: left;" :title="deviceSubNo.title">{{deviceSubNo.title}}</td>
                    <td style="text-align: left;" v-if="deviceMaintPlan.suitFlag" :title="deviceSubNo.suitName || '无'">{{deviceSubNo.suitName || '无'}}</td>
                    <td style="text-align: left;">{{deviceSubNo.tmpNo}}</td>
                    <td>{{deviceSubNo.wrntDueTime}}</td>
                    <td style="text-align: left;">
                        <span :title="roleMerchtVendor(deviceSubNo)">{{ roleMerchtVendor(deviceSubNo) }}</span>
                    </td>
                    <td style="text-align: left;">
                        <span :title="roleMerchtServicer(deviceSubNo)">{{ roleMerchtServicer(deviceSubNo) }}</span>
                    </td>
                    <td>
                        <span v-if="deviceSubNo.contractId != null">是</span>
                        <span v-else>否</span>
                    </td>
                    <td style="text-align: left;" :title="deviceSubNo.servcTitle || '无'">{{deviceSubNo.servcTitle || '无'}}</td>
                    <td style="text-align: center;">
                        <el-form-item>
                            <el-date-picker v-model="deviceSubNo.yqFinishTime" :picker-options="pickerOptions0" type="datetime" placeholder="请选择" @change="yqFinishTimeChange(deviceSubNo)"></el-date-picker>
                        </el-form-item>
                    </td>
                    <td style="text-align: right;" v-if="deviceMaintPlan.cronFlag">
                        <span>{{deviceSubNo.yqFinishHours}}</span>
                    </td>
                    <td style="text-align: right;">
                        <el-form-item :prop="'deviceSubNoCatList.' + index + '.yqFinishAotHr'" :rules="{validator: inputYqFinishAotHr, trigger: 'blur'}">
                            <el-input type="number" min="0" class="input-content-right" @change="quantityYqFinishAotHr(deviceSubNo);" v-model.number="deviceSubNo.yqFinishAotHr"></el-input>
                        </el-form-item>
                    </td>
                    <td style="text-align: left;">
                        <a class="swb-btn-link" @click="selectServicer(deviceSubNo, index)">选择服务商</a>
                        <a class="swb-btn-link" v-if="deviceSubNo.ssuId == null" @click="selectMsu(deviceSubNo, index)">选择服务</a>
                        <a class="swb-btn-link" v-else @click="removeMsu(deviceSubNo, index)">移除服务</a>
                        <a class="swb-btn-link" @click="deleteSelectDeviceSubNo(index)">移除</a>
                    </td>
                </tr>
                </tbody>
                <tfoot class="foot" v-else>
                <tr class="row">
                    <td colspan="11" v-if="!deviceMaintPlan.suitFlag">
                        <span>未选择资产</span>
                    </td>
                    <td colspan="12" v-if="deviceMaintPlan.suitFlag">
                        <span>未选择资产</span>
                    </td>
                </tr>
                </tfoot>
            </table>
        </div>
    </el-form>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { showAssetSelectDlg, openShopDeviceSuitSelectDlg } from './selectDlg'
    import { openMsuListByGoodsIdDlg, openMsuListByGoodsCatIdDlg, openSpecServcSelectDlg } from '../servc/selectDlg'
    import { openServicerSelectComnDlg } from '../servicer/selectDlg'
    import { openCronEditorDlg } from '../cron/selectDlg'
    import { setPlanYqInfoDlg } from './dialog'
    import { showDevcSelectDlg } from '../devc/selectDlg'
    //
    import shopDevcApi from '../../api/shopDevc'
    import devcApi from '../../api/devc'
    import contractApi from '../../api/contract'
    import userApi from '../../api/user'
    import comnApi from '../../api/comn'
    //
    export default {
        name: 'swb-device-maint-plan-add',
        path: '',
        avlScopes: 'retailer',
        desc: '新增机构资产保养',
        props: {
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        data: function () {
            return {
                deviceMaintPlan: {
                    title: null,
                    cronFlag: false,
                    theDateTime: null,
                    theExprDesc: null,
                    limitEndTime: null,
                    theDataJson: null,
                    theData: null,
                    dataExType: null,
                    itemList: [],
                    suitFlag: false,
                    //
                    deviceSubNoWrntList: [], // 保内-列表
                    deviceSubNoCatList: [],
                },
                //
                deviceSubNoList: [],    // 保外-列表
                deviceCatMap: {},       // 保外-分类分组
                //
                // 页签
                tableState: [{
                    "text": "约定期保外",
                    "value": 1,
                }, {
                    "text": "约定期保内",
                    "value": 0,
                }],
                checkStateValue: 1,
                // 分类页签
                tableStateForCat: [],
                stateValue: null,
                merchantServicer: null,
                currentDate: null,
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                comLevel: null,
                comId: null,
                suitList: [],
                suitFlag: false,
                //
                selectCount: 0,
            }
        },
        created: function () {
            this.merchantServicer = getEnumInfoWith("merchantType", "name", "Servicer").value;
            this.currentDate = (new Date()).format("yyyy-MM-dd");
            //
            if(!Utils.isNoB(this.filter)) {
                let id = this.filter.id;
                if(!Utils.isNoB(id)) {
                    this.getDeviceMaintPlan(id);
                }
            }
        },
        methods: {
            suitFlagChange: function () {
                if(this.suitFlag != this.deviceMaintPlan.suitFlag) {
                    this.deviceSubNoList = Utils.merge([]);
                    this.deviceMaintPlan.deviceSubNoCatList = Utils.merge([]);
                    this.deviceMaintPlan.deviceSubNoWrntList = Utils.merge([]);
                    this.tableStateForCat = Utils.merge([]);
                    this.deviceCatMap = Utils.merge({});
                    this.stateValue = null;
                    this.suitFlag = this.deviceMaintPlan.suitFlag;
                    this.selectCount = 0;
                }

            },
            handleTabClick(val) {
                this.checkStateValue = val;
                if(this.checkStateValue == 0) {     // 保内
                    //
                } else {
                    // 保外
                }
            },
            handleCatTabClick: function (val) {    // 分类页签切换
                this.stateValue = val;
                let deviceCatMap = this.deviceCatMap || {};
                //
                this.deviceMaintPlan.deviceSubNoCatList = deviceCatMap[val];
            },
            checkNull: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            },
            checkTheDateTime: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    if(new Date() >= value) {
                        callback(new Error('保养时间需大于当前时间'));
                    } else {
                        callback();
                    }
                }
            },
            checkNone: function (rule, value, callback) {
                callback();
            },
            yqFinishTimeChange: function (deviceSubNo) {
                if(!this.checkWrnt(deviceSubNo)) {
                    // 保外 deviceSubNoCatList
                    let deviceCatMap = this.deviceCatMap;
                    if(!Utils.isNoB(deviceCatMap)) {
                        for(let key in deviceCatMap) {
                            let deviceSubNoCatList = deviceCatMap[key];
                            //
                            for(let i = 0; i < deviceSubNoCatList.length; i++) {
                                let deviceSubNoCat = deviceSubNoCatList[i];
                                if(deviceSubNoCat.id == deviceSubNo.id) {
                                    deviceSubNoCat.yqFinishTime = deviceSubNo.yqFinishTime;
                                }
                            }
                        }
                        this.deviceCatMap = Utils.merge({}, deviceCatMap);
                        let deviceSubNoCatList = deviceCatMap[this.stateValue];
                        this.deviceMaintPlan.deviceSubNoCatList = Utils.merge([], deviceSubNoCatList);
                    }
                }
            },
            // 要求完成小时校验
            inputYqFinishHours: function (rule, value, callback) {
                if(!Utils.isNoB(value) && value <= 0) {
                    callback(new Error('要求完成小时应为正整数！'));
                } else {
                    callback();
                }
            },
            // 要求完成小时校验
            quantityYqFinishHours: function (deviceSubNo) {
                if(!Utils.isIntStr(deviceSubNo.yqFinishHours)) {
                    deviceSubNo.yqFinishHours = null;
                    MsgBox.warning("要求完成小时必须为正整数");
                }
                if(!this.checkWrnt(deviceSubNo)) {
                    // 保外 deviceSubNoCatList
                    let deviceCatMap = this.deviceCatMap;
                    if(!Utils.isNoB(deviceCatMap)) {
                        for(let key in deviceCatMap) {
                            let deviceSubNoCatList = deviceCatMap[key];
                            //
                            for(let i = 0; i < deviceSubNoCatList.length; i++) {
                                let deviceSubNoCat = deviceSubNoCatList[i];
                                if(deviceSubNoCat.id == deviceSubNo.id) {
                                    deviceSubNoCat.yqFinishHours = deviceSubNo.yqFinishHours;
                                }
                            }
                        }
                        this.deviceCatMap = Utils.merge({}, deviceCatMap);
                        let deviceSubNoCatList = deviceCatMap[this.stateValue];
                        this.deviceMaintPlan.deviceSubNoCatList = Utils.merge([], deviceSubNoCatList);
                    }
                }
            },
            // 预警小时校验
            inputYqFinishAotHr: function (rule, value, callback) {
                if(!Utils.isNoB(value) && value <= 0) {
                    callback(new Error('预警小时应为正整数！'));
                } else {
                    callback();
                }
            },
            // 预警小时校验
            quantityYqFinishAotHr: function (deviceSubNo) {
                if(!Utils.isIntStr(deviceSubNo.yqFinishAotHr)) {
                    deviceSubNo.yqFinishAotHr = null;
                    MsgBox.warning("预警小时必须为正整数");
                } else {
                    let cronFlag = this.deviceMaintPlan.cronFlag;
                    if(Utils.isNaturalStr(deviceSubNo.yqFinishAotHr)) {
                        if(!Utils.isTrue(cronFlag) && deviceSubNo.yqFinishAotHr > 0 && Utils.isNoB(deviceSubNo.yqFinishTime)) {
                            MsgBox.warning("请设置工单截止时间");
                        }
                        if(Utils.isTrue(cronFlag) && deviceSubNo.yqFinishAotHr > 0 && Utils.isNoB(deviceSubNo.yqFinishHours)) {
                            MsgBox.warning("请设置要求完成小时");
                        }
                    }
                }
                if(!this.checkWrnt(deviceSubNo)) {
                    // 保外 deviceSubNoCatList
                    let deviceCatMap = this.deviceCatMap;
                    if(!Utils.isNoB(deviceCatMap)) {
                        for(let key in deviceCatMap) {
                            let deviceSubNoCatList = deviceCatMap[key];
                            //
                            for(let i = 0; i < deviceSubNoCatList.length; i++) {
                                let deviceSubNoCat = deviceSubNoCatList[i];
                                if(deviceSubNoCat.id == deviceSubNo.id) {
                                    deviceSubNoCat.yqFinishAotHr = deviceSubNo.yqFinishAotHr;
                                }
                            }
                        }
                        this.deviceCatMap = Utils.merge({}, deviceCatMap);
                        let deviceSubNoCatList = deviceCatMap[this.stateValue];
                        this.deviceMaintPlan.deviceSubNoCatList = Utils.merge([], deviceSubNoCatList);
                    }
                }
            },
            // 设置工单截止要求
            setYqInfo: function (cronFlag, theDateTime) {
                let self = this;
                let params = {
                    planType: "保养",
                    viewFlag: false,
                    cronFlag: cronFlag,
                    theDateTime: theDateTime
                };
                setPlanYqInfoDlg(params, function (result) {
                    // 保内 deviceSubNoWrntList
                    let deviceSubNoWrntList = self.deviceMaintPlan.deviceSubNoWrntList || [];
                    for(let i = 0; i < deviceSubNoWrntList.length; i++) {
                        let deviceSubNo = deviceSubNoWrntList[i];
                        deviceSubNo.yqFinishTime = result.yqFinishTime;
                        deviceSubNo.yqFinishAotHr = result.yqFinishAotHr;
                        if(Utils.isTrue(cronFlag)) {
                            deviceSubNo.yqFinishHours = result.yqFinishHours;
                        }
                    }
                    self.deviceMaintPlan.deviceSubNoWrntList = Utils.merge([], deviceSubNoWrntList);
                    // 保外 deviceSubNoCatList
                    let deviceCatMap = self.deviceCatMap;
                    if(!Utils.isNoB(deviceCatMap)) {
                        for(let key in deviceCatMap) {
                            let deviceSubNoCatList = deviceCatMap[key];
                            //
                            for(let i = 0; i < deviceSubNoCatList.length; i++) {
                                let deviceSubNo = deviceSubNoCatList[i];
                                deviceSubNo.yqFinishTime = result.yqFinishTime;
                                deviceSubNo.yqFinishAotHr = result.yqFinishAotHr;
                                if(Utils.isTrue(cronFlag)) {
                                    deviceSubNo.yqFinishHours = result.yqFinishHours;
                                }
                            }
                        }
                        self.deviceCatMap = Utils.merge({}, deviceCatMap);
                        let deviceSubNoCatList = deviceCatMap[self.stateValue];
                        self.deviceMaintPlan.deviceSubNoCatList = Utils.merge([], deviceSubNoCatList);
                    }
                });
            },
            getDeviceMaintPlan(id) {
                let self = this;
                let postData = {
                    id: id
                };
                let msgBoxDlg = MsgBox.loading();
                devcApi.getDeviceMaintPlanDetail(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let deviceMaintPlan = result.data;
                        deviceMaintPlan.deviceSubNoWrntList = []; // 保内-列表
                        deviceMaintPlan.deviceSubNoCatList = [];
                        self.suitFlag = deviceMaintPlan.suitFlag;
                        let filter = self.filter;
                        filter.retailerComId = deviceMaintPlan.shopId;
                        filter.retailerId = deviceMaintPlan.retailerId;
                        self.filter = Utils.merge({}, filter);
                        if(deviceMaintPlan.cronFlag) {
                            deviceMaintPlan.theDataJson = JSON.decode(deviceMaintPlan.theData);
                        }
                        deviceMaintPlan.dataExType = 0;
                        if(deviceMaintPlan.limitEndTime != null) {
                            deviceMaintPlan.dataExType = 2;
                        }
                        let optionFlag = filter.optionFlag;
                        if(!Utils.isNoB(optionFlag) && optionFlag == 'copyMaintPlan') {
                            deviceMaintPlan.theDateTime = null;
                            deviceMaintPlan.theExprDesc = null;
                            deviceMaintPlan.limitEndTime = null;
                            deviceMaintPlan.theDataJson = null;
                            deviceMaintPlan.theData = null;
                        }
                        self.deviceMaintPlan = Utils.merge({}, deviceMaintPlan);
                        let itemList = deviceMaintPlan.itemList;
                        let newDeviceSubNoList = itemList.pluck('shopDevice');
                        newDeviceSubNoList.forEach(function (deviceSubNo) {
                            let curItem = itemList.find(function (item) {
                                return item.shopDevice.id == deviceSubNo.id;
                            });
                            deviceSubNo = Object.assign(deviceSubNo, deviceSubNo.devcMgmtAspkt);
                            deviceSubNo = Object.assign(deviceSubNo, deviceSubNo.devcAssetAspkt);
                            deviceSubNo = Object.assign(deviceSubNo, deviceSubNo.devcMaintAspkt);
                            deviceSubNo.ssuId = curItem.ssuId;
                            deviceSubNo.servcId = curItem.servcId;
                            deviceSubNo.servcTitle = curItem.servcTitle;
                            deviceSubNo.yqFinishTime = curItem.yqFinishTime;
                            deviceSubNo.yqFinishHours = curItem.yqFinishHours;
                            deviceSubNo.yqFinishAotHr = curItem.yqFinishAotHr;
                            if(self.checkWrnt(deviceSubNo)) {
                                if(deviceSubNo.sellerType == self.merchantServicer) {
                                    deviceSubNo.servicerId = curItem.servicerId;
                                    deviceSubNo.servicerName = curItem.servicerName;
                                    deviceSubNo.sellerName = deviceSubNo.sellerName || '无';
                                }
                            } else {
                                deviceSubNo.servicerId = curItem.servicerId;
                                deviceSubNo.servicerName = curItem.servicerName;
                            }
                            deviceSubNo.contractId = curItem.contractId;
                        });
                        self.handelDeviceList(newDeviceSubNoList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            selectCronInfo: function () {
                let self = this;
                let deviceMaintPlan = this.deviceMaintPlan;
                let params = {};
                params.cronJson = deviceMaintPlan.theDataJson || {};
                params.cronSecondNeeded = false;
                params.timeLimit = {};
                //
                let dataExType = deviceMaintPlan.dataExType;
                let timeLimit = {};
                timeLimit.limitType = dataExType;
                if(dataExType == 2) {   // 限制时间
                    timeLimit.limitTimed = deviceMaintPlan.limitEndTime;
                } else {
                    timeLimit.limitTimed = null;
                }
                params.timeLimit = timeLimit;
                //
                params.fixedYear = false;
                openCronEditorDlg(params, function (jsonResult) {
                    deviceMaintPlan.theDataJson = jsonResult.data;
                    console.log(JSON.encode(jsonResult.data));
                    deviceMaintPlan.theExprDesc = jsonResult.dataDesc;
                    //
                    let dataEx = jsonResult.dataEx;
                    if(!Utils.isNoB(dataEx)) {
                        deviceMaintPlan.dataExType = dataEx.limitType;
                        if(dataEx.limitType == 0) { // 无限制
                            deviceMaintPlan.limitEndTime = null;
                        } else if(dataEx.limitType == 2) {  // 限制时间
                            deviceMaintPlan.limitEndTime = dataEx.limitTimed || null;
                        }
                    } else {
                        // 不支持-截止时间

                    }
                    if(!Utils.isNoB(deviceMaintPlan)) {
                        self.getTheDateTime(deviceMaintPlan);
                    } else {
                        self.deviceMaintPlan = Utils.merge({}, deviceMaintPlan);
                    }
                    self.checkInfo();
                });
            },
            getTheDateTime: function (deviceMaintPlan) {
                let self = this;
                let postData = {
                    theData: JSON.encode(deviceMaintPlan.theDataJson)
                };
                comnApi.getNextExecutionTime(postData, function (result) {
                    if(result.type == 'info') {
                        let theDateTime = result.data;
                        if(!Utils.isNoB(theDateTime)) {
                            deviceMaintPlan.theDateTime = new Date(theDateTime);
                        }
                        //
                        self.deviceMaintPlan = Utils.merge({}, deviceMaintPlan);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            checkWrnt(deviceSubNo){
                return (deviceSubNo.wrntDueTime == null || deviceSubNo.wrntDueTime.format('yyyy-MM-dd') >= this.currentDate) && !deviceSubNo.imported;
            },
            checkRoleMerchtVendor(deviceSubNo){
                return this.checkWrnt(deviceSubNo) && deviceSubNo.sellerType != this.merchantServicer;
            },
            roleMerchtVendor(deviceSubNo){
                if(this.checkRoleMerchtVendor(deviceSubNo)) {
                    return deviceSubNo.sellerName || '无';
                }
                return '';
            },
            roleMerchtServicer(deviceSubNo){
                if(this.checkWrnt(deviceSubNo)) {
                    if(deviceSubNo.sellerType == this.merchantServicer) {
                        deviceSubNo.servicerId = deviceSubNo.sellerId;
                        deviceSubNo.servicerName = deviceSubNo.sellerName;
                        //
                        return deviceSubNo.sellerName || '无';
                    }
                } else {
                    return deviceSubNo.servicerName;
                }
                return '';
            },
            handelDeviceList(newDeviceSubNoList){
                let self = this;
                //
                let selectCount = self.selectCount || 0;
                let deviceSubNoList = self.deviceSubNoList || [];           // 保外
                let deviceSubNoWrntList = self.deviceMaintPlan.deviceSubNoWrntList || [];   // 保内
                //
                let deviceSubNoIds = deviceSubNoList.pluck("id");
                if(newDeviceSubNoList != null && newDeviceSubNoList.length > 0) {
                    if(newDeviceSubNoList.length > 50) {
                        MsgBox.warning("每次保养不可超过50个资产！");
                        return;
                    }
                    //
                    let isForEndCount = 0;
                    for(let i = 0; i < newDeviceSubNoList.length; i++) {
                        let deviceSubNo = newDeviceSubNoList[i];
                        // 查询-合同相关设备
                        let postData = {
                            devcSubNoId: deviceSubNo.id,
                            servcType: getEnumInfoWith('servcType', 'name', 'ProductMaint').value,
                        };
                        isForEndCount++;
                        let isFinished = isForEndCount == newDeviceSubNoList.length;
                        self.makeMaintPlanDeviceInfo(deviceSubNoIds, deviceSubNo, deviceSubNoWrntList, deviceSubNoList, isFinished);
                    }
                    selectCount += newDeviceSubNoList.length;
                    self.selectCount = Utils.merge(0, selectCount);
                }
            },
            makeMaintPlanDeviceInfo: function (deviceSubNoIds, deviceSubNo, deviceSubNoWrntList, deviceSubNoList, isFinished) {
                let self = this;
                if(deviceSubNoIds.indexOf(deviceSubNo.id) < 0) {
                    // 保养的服务信息
                    if(Utils.isNoB(deviceSubNo.ssuId)) {
                        deviceSubNo.ssuId = null;
                        deviceSubNo.servcId = null;
                        deviceSubNo.servcTitle = null;
                    }
                    //
                    if(self.checkWrnt(deviceSubNo)) {
                        // 保内的不使用默认服务商的服务
                        deviceSubNo.ssuId = null;
                        deviceSubNo.servcId = null;
                        deviceSubNo.servcTitle = null;
                        // 保内
                        deviceSubNoWrntList.push(deviceSubNo);
                    } else {
                        // 保外
                        deviceSubNoList.push(deviceSubNo);
                    }
                }
                //
                if(isFinished) {
                    self.deviceMaintPlan.deviceSubNoWrntList = Utils.merge([], deviceSubNoWrntList);
                    self.makeDeviceGroupInfo(deviceSubNoList);
                }
            },
            // 设置-设备分租
            makeDeviceGroupInfo: function (deviceSubNoList) {
                let self = this;
                // --- 保外设备-按照分类分组
                if(!Utils.isNoB(deviceSubNoList) && deviceSubNoList.length > 0) {
                    let deviceCatMap = {};
                    //
                    let tableStateForCat = [];
                    for(let i = 0; i < deviceSubNoList.length; i++) {
                        let deviceSubNo = deviceSubNoList[i];
                        let catId = deviceSubNo.catId;
                        //
                        let deviceCatGroup = deviceCatMap[catId] || null;
                        if(Utils.isNoB(deviceCatGroup)) {
                            let group = [];
                            group.push(deviceSubNo);
                            //
                            deviceCatMap[catId] = group;
                            // 分类页签
                            let catGroup = {};
                            catGroup.text = deviceSubNo.catName;
                            catGroup.value = catId;
                            tableStateForCat.push(catGroup);
                        } else {
                            deviceCatGroup.push(deviceSubNo);
                        }
                    }
                    self.deviceCatMap = Utils.merge({}, deviceCatMap);
                    // self.deviceSubNoList = Utils.merge([], deviceSubNoList);
                    // 分类-页签
                    if(tableStateForCat != null && tableStateForCat.length > 0) {
                        this.tableStateForCat = Utils.merge([], tableStateForCat);
                        let catId = tableStateForCat[0].value;
                        //
                        this.stateValue = catId;
                        this.deviceMaintPlan.deviceSubNoCatList = Utils.merge([], deviceCatMap[catId]);    // 设置第一个页签数据
                    }
                }
            },
            selectDevice: function () {
                if(Utils.isTrue(this.deviceMaintPlan.suitFlag)) {
                    this.toSelectSuit();
                } else {
                    this.toSelectDeviceSubNo();
                }
            },
            // 选择设备
            toSelectDeviceSubNo: function () {
                let self = this;
                let selectIds = [];
                if(this.checkStateValue == 0) {
                    let deviceSubNoWrntList = self.deviceMaintPlan.deviceSubNoWrntList || [];
                    selectIds = deviceSubNoWrntList.pluck("id");
                } else {
                    let deviceSubNoList = self.deviceSubNoList || [];
                    selectIds = deviceSubNoList.pluck("id");
                }
                let params = {
                    filter: {
                        retailerComId: self.filter.retailerComId,
                        maintFlag: true,
                    },
                    initSelectIds: selectIds
                };
                showDevcSelectDlg(params, function (newDeviceSubNoList) {
                    self.handelDeviceList(newDeviceSubNoList);
                });
            },
            // 移除选中的设备
            deleteSelectDeviceSubNo: function (index) {
                let self = this;
                this.$confirm('确定要移除当前资产吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                        let checkStateValue = self.checkStateValue;
                        if(checkStateValue === 0) {  // 移除保内
                            let deviceSubNoWrntList = self.deviceMaintPlan.deviceSubNoWrntList || [];
                            let delItem = deviceSubNoWrntList[index];
                            deviceSubNoWrntList.splice(index, 1);
                            //
                            self.deviceMaintPlan.deviceSubNoWrntList = Utils.merge([], deviceSubNoWrntList);
                            if(self.suitList != null && self.suitList.length > 0 && delItem.suitId != null) {
                                for(let i = 0; i < self.suitList.length; i++) {
                                    if(self.suitList[i].id == delItem.suitId) {
                                        self.suitList.splice(i, 1);
                                        break;
                                    }
                                }
                            }
                        } else {
                            // 移除保外
                            let deviceCatMap = self.deviceCatMap;
                            let deviceSubNoCatList = self.deviceMaintPlan.deviceSubNoCatList;
                            let catId = deviceSubNoCatList[0].catId;
                            let delItem = deviceSubNoCatList[index];
                            //
                            let dbList = self.deviceSubNoList;
                            for(let i = 0; i < dbList.length; i++) {
                                if(dbList[i].id == delItem.id) {
                                    dbList.splice(i, 1);
                                    break;
                                }
                            }
                            self.deviceSubNoList = dbList;
                            //
                            deviceSubNoCatList.splice(index, 1);
                            if(deviceSubNoCatList.length <= 0) {
                                delete deviceCatMap[catId];
                                let tableStateForCat = self.tableStateForCat;
                                for(let i = 0; i < tableStateForCat.length; i++) {
                                    if(tableStateForCat[i].value == catId) {
                                        tableStateForCat.splice(i, 1);
                                        break;
                                    }
                                }
                                if(tableStateForCat.length > 0) {
                                    self.handleCatTabClick(tableStateForCat[0].value);
                                } else {
                                    self.stateValue = null;
                                    self.deviceSubNoCatList = [];
                                }
                            } else {
                                deviceCatMap[catId] = deviceSubNoCatList;
                            }
                            self.deviceCatMap = Utils.merge({}, deviceCatMap);
                            if(self.suitList != null && self.suitList.length > 0 && delItem.suitId != null) {
                                for(let i = 0; i < self.suitList.length; i++) {
                                    if(self.suitList[i].id == delItem.suitId) {
                                        self.suitList.splice(i, 1);
                                        break;
                                    }
                                }
                            }
                        }
                        //
                        let selectCount = self.selectCount || 0;
                        selectCount = selectCount - 1;
                        self.selectCount = Utils.merge(0, selectCount);
                    }
                ).catch(function () {
                });
            },
            // 批量设置服务
            selectMsuForAll: function (deviceSubNo) {
                let self = this;
                let deviceMaintPlan = this.deviceMaintPlan;
                let servcType = getEnumInfoWith('servcType', 'name', 'ProductMaint').value;
                //
                let deviceSubNoCatList = this.deviceMaintPlan.deviceSubNoCatList || [];     // 当前分类页签下的 设备
                // 质保外
                let goodsCatId = deviceSubNo.catId;
                let defServicerId = null;
                if(this.checkWrnt(deviceSubNo)) {
                    if(deviceSubNo.sellerType == this.merchantServicer) {
                        defServicerId = deviceSubNo.sellerId;
                    }
                }
                if(Utils.isNoB(defServicerId)) {
                    defServicerId = deviceSubNo.servicerId;
                }
                if(Utils.isNoB(defServicerId)) {
                    MsgBox.warning("没有指定服务商，不能选择服务！");
                } else {
                    let params = {
                        goodsCatId: goodsCatId,
                        servicerId: defServicerId,
                        servcType: servcType,
                    };
                    openMsuListByGoodsCatIdDlg(params, function (msu) {
                        let ssuId = msu.ssuId;
                        let servcId = msu.servcId;
                        let msuTitle = msu.title;
                        //
                        for(let i = 0; i < deviceSubNoCatList.length; i++) {
                            let subNo = deviceSubNoCatList[i];
                            subNo.ssuId = ssuId;
                            subNo.servcId = servcId;
                            subNo.servcTitle = msuTitle;
                        }
                        //
                        self.deviceCatMap[deviceSubNo.catId] = Utils.merge([], deviceSubNoCatList);
                    });
                }
            },
            // 选择服务
            selectMsu: function (deviceSubNo, index) {
                let self = this;
                let deviceSubNoList = self.deviceSubNoList || [];
                let deviceSubNoWrntList = self.deviceMaintPlan.deviceSubNoWrntList || [];
                //
                let deviceMaintPlan = this.deviceMaintPlan;
                let servcType = getEnumInfoWith('servcType', 'name', 'ProductMaint').value;
                //
                let currentDate = deviceMaintPlan.theDateTime;
                if(!Utils.isNoB(currentDate)) {
                    self.currentDate = currentDate.format("yyyy-MM-dd");
                }
                let sellerType = deviceSubNo.sellerType;
                if(this.checkRoleMerchtVendor(deviceSubNo)) {
                    // 按供应商找服务
                    let goodsId = deviceSubNo.goodsId;
                    let srcVendorId = deviceSubNo.srcVendorId;
                    if(Utils.isNoB(srcVendorId)) {
                        srcVendorId = deviceSubNo.sellerId;
                    }
                    let params = {
                        goodsId: goodsId,
                        srcVendorId: srcVendorId,
                        sellerType: sellerType,
                        servcType:servcType
                    };
                    openMsuListByGoodsIdDlg(params, function (msu) {
                        //
                        deviceSubNo.ssuId = msu.ssuId;
                        deviceSubNo.servcId = msu.servcId;
                        deviceSubNo.servcTitle = msu.title;
                        // 为了再次选择设备不变服务信息
                        let svcSubNo = deviceSubNoWrntList.find(function (item) {
                            if(item.id == deviceSubNo.id) {
                                return item;
                            }
                        });
                        svcSubNo.ssuId = msu.ssuId;
                        svcSubNo.servcId = msu.servcId;
                        svcSubNo.servcTitle = msu.title;
                        self.deviceMaintPlan.deviceSubNoWrntList = Utils.merge([], deviceSubNoWrntList);
                    });
                } else {
                    // 按服务商找服务
                    if(deviceSubNo != null) {
                        let goodsCatId = deviceSubNo.catId;
                        let defServicerId = null;
                        if(this.checkWrnt(deviceSubNo)) {
                            if(deviceSubNo.sellerType == this.merchantServicer) {
                                defServicerId = deviceSubNo.sellerId;
                            }
                        }
                        if(Utils.isNoB(defServicerId)) {
                            defServicerId = deviceSubNo.servicerId;
                        }
                        if(Utils.isNoB(defServicerId)) {
                            MsgBox.warning("没有指定服务商，不能选择服务！");
                        } else {
                            let params = {
                                servicerId: defServicerId,
                                servcType: servcType,
                                devcId: deviceSubNo.id,
                                devcDefId: deviceSubNo.devcDefId,
                                retailerId: deviceSubNo.retailerId,
                                retailerComId: deviceSubNo.retailerBizUnitId,
                                devcGroupId: deviceSubNo.devcGroupId
                            };
                            openSpecServcSelectDlg(params, function (msu) {
                                deviceSubNo.ssuId = msu.ssuId;
                                deviceSubNo.servcId = msu.servcId;
                                deviceSubNo.servcTitle = msu.title;
                                // 为了再次选择设备不变服务信息
                                if(Utils.isNoB(deviceSubNoList) && deviceSubNoList.length > 0) {
                                    let svcSubNo = deviceSubNoList.find(function (item) {
                                        if(item.id == deviceSubNo.id) {
                                            return item;
                                        }
                                    });
                                    svcSubNo.ssuId = msu.ssuId;
                                    svcSubNo.servcId = msu.servcId;
                                    svcSubNo.servcTitle = msu.title;
                                }
                                if(!Utils.isNoB(index)) {
                                    self.deviceSubNoList = Utils.merge([], deviceSubNoList);
                                    self.deviceCatMap[deviceSubNo.catId][index] = deviceSubNo;
                                }
                            });
                        }
                    }
                }
            },
            // 移除选中的服务
            removeMsu: function (deviceSubNo, index) {
                let self = this;
                this.$confirm('确定要移除当前服务吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    //
                    deviceSubNo.ssuId = null;
                    deviceSubNo.servcId = null;
                    deviceSubNo.servcTitle = null;
                    //
                    if(!Utils.isNoB(index)) {
                        self.deviceCatMap[deviceSubNo.catId][index] = deviceSubNo;
                    }
                }).catch(function () {
                });
            },
            //
            // 切换服务商
            selectServicer: function (deviceSubNo, index) {
                let self = this;
                let params = {
                    showDef: true,
                    showServcContract: true,
                    servcType: getEnumInfoWith("servcType", "name", "ProductMaint").value,
                    devcGroupId: deviceSubNo.devcGroupId,
                    multiSelect: false,
                    retailerComId: deviceSubNo.retailerBizUnitId
                };
                openServicerSelectComnDlg(self, params, function (result) {
                    let servicer = result.checkedList;
                    deviceSubNo.servicerId = servicer.id;
                    deviceSubNo.servicerName = servicer.name;
                    deviceSubNo.contractNo = null;
                    deviceSubNo.contractId = null;
                    deviceSubNo.ssuId = null;
                    deviceSubNo.servcId = null;
                    deviceSubNo.servcTitle = null;
                    //
                    let itemList = self.deviceMaintPlan.deviceSubNoCatList;
                    itemList[index] = deviceSubNo;
                    self.deviceMaintPlan.deviceSubNoCatList = Utils.merge([], itemList);
                });
            },
            //
            checkInfo(changeCronFlag) {
                this.$refs['voucherInfo'].validate(function (valid) {
                });
                if(Utils.isTrue(changeCronFlag)) {
                    let cronFlag = this.deviceMaintPlan.cronFlag;
                    if(!Utils.isTrue(cronFlag)) {
                        this.deviceMaintPlan.theDateTime = null;
                    } else {
                        this.deviceMaintPlan.theExprDesc = null;
                        this.deviceMaintPlan.theDataJson = null;
                    }
                }
            },
            // 保存设备保养计划
            getDlgResult: function () {
                let self = this;
                let deviceMaintPlan = this.deviceMaintPlan;
                //
                let deviceSubNoList = Utils.merge([], this.deviceMaintPlan.deviceSubNoWrntList);
                // 保外
                let deviceCatMap = this.deviceCatMap || {};
                for(let key in deviceCatMap) {
                    let deviceSubNoItems = deviceCatMap[key];
                    //
                    deviceSubNoList.add(deviceSubNoItems);
                }
                //
                let filter = this.filter;
                deviceMaintPlan.shopId = filter.retailerComId;
                //
                let result = null;
                this.$refs['voucherInfo'].validate(function (valid) {
                    result = {};
                    if(valid) {
                        if(deviceSubNoList == null || deviceSubNoList.length <= 0) {
                            result.type = 'warn';
                            result.message = '请选择资产！';
                            return;
                        }
                        //
                        let cronFlag = deviceMaintPlan.cronFlag;
                        let itemList = [];
                        for(let i = 0; i < deviceSubNoList.length; i++) {
                            let deviceSubNo = deviceSubNoList[i];
                            //
                            let deviceTitle = deviceSubNo.title;
                            //
                            let item = {};
                            if(Utils.isNoB(deviceSubNo.servcId)) {
                                result.type = 'warn';
                                result.message = "【" + deviceTitle + "】未选择服务！";
                                return;
                            }
                            // 组装数据
                            item.tmpNo = deviceSubNo.tmpNo;
                            // 服务信息
                            item.ssuId = deviceSubNo.ssuId;
                            item.servcId = deviceSubNo.servcId;
                            item.servcTitle = deviceSubNo.servcTitle;
                            // 服务商信息
                            item.contractId = deviceSubNo.contractId;
                            item.contractNo = deviceSubNo.contractNo;
                            item.servicerId = deviceSubNo.servicerId;
                            item.servicerName = deviceSubNo.servicerName;
                            // 要求完成小时，工单截止时间，提前预警小时
                            item.yqFinishHours = deviceSubNo.yqFinishHours;
                            item.yqFinishAotHr = deviceSubNo.yqFinishAotHr;
                            if(!Utils.isTrue(cronFlag) && !Utils.isNoB(deviceSubNo.yqFinishAotHr) && deviceSubNo.yqFinishAotHr > 0 && Utils.isNoB(deviceSubNo.yqFinishTime)) {
                                MsgBox.warning("还有未设置工单截止时间的，请先设置工单截止时间");
                                return;
                            }
                            if(Utils.isTrue(cronFlag) && !Utils.isNoB(deviceSubNo.yqFinishAotHr) && deviceSubNo.yqFinishAotHr > 0 && Utils.isNoB(deviceSubNo.yqFinishHours)) {
                                MsgBox.warning("还有未设置要求完成小时的，请先设置要求完成小时");
                                return;
                            }
                            //
                            if(!Utils.isNoB(deviceSubNo.yqFinishTime)) {
                                item.yqFinishTime = deviceSubNo.yqFinishTime.format("yyyy-MM-dd HH:mm");
                            }
                            //
                            itemList.push(item);
                        }
                        deviceMaintPlan.itemList = itemList;
                        let theData = deviceMaintPlan.theDataJson;
                        deviceMaintPlan.theData = JSON.encode(theData);
                        if(!cronFlag) {
                            deviceMaintPlan.theDateTime = deviceMaintPlan.theDateTime.format('yyyy-MM-dd HH:mm:ss');
                        }
                        console.log(deviceMaintPlan);
                        result.type = 'info';
                        result.data = deviceMaintPlan;
                    } else {
                        result.type = 'warn';
                        result.message = '校验失败';
                    }
                });
                return result;
            },
            toSelectSuit: function () {
                let self = this;
                let filter = self.filter;
                let suitList = self.suitList || [];
                let deviceSubNoList = self.deviceSubNoList || [];
                let deviceSubNoWrntList = self.deviceMaintPlan.deviceSubNoWrntList || [];
                let tmpNos = deviceSubNoList.pluck("tmpNo") || [];
                let wrntTmpNos = deviceSubNoWrntList.pluck("tmpNo") || [];
                let selectTmpNos = tmpNos.concat(wrntTmpNos);
                let parmas = {
                    thisComId: filter.retailerComId,
                    thisComLevel: filter.comLevel,
                    includeSubComs: false,
                    includeItems: false,
                    servcType: getEnumInfoWith('servcType', 'name', 'ProductMaint').value,
                    beyondWrnt: this.checkStateValue == 0,
                    relFlag: true,  // 关联子设备查询
                };
                openShopDeviceSuitSelectDlg(parmas, function (result) {
                    let list = [];
                    let resultSuit = suitList.concat(result);
                    self.suitList = resultSuit;
                    result.forEach(function (suit) {
                        let isAdd = true;
                        suitList.forEach(function (item) {
                            if(item.id == suit.id) {
                                isAdd = false;
                            }
                        });
                        if(isAdd) {
                            list.add(suit);
                        }
                    });
                    self.getSuitDevice(list);
                }, selectTmpNos)
            },
            getSuitDevice: function (suitList) {
                let shopDeviceSvcSubNoList = [];
                for(let i = 0; i < suitList.length; i++) {
                    let suit = suitList[i];
                    let shopDeviceSvcSubNo = suit.shopDevice;
                    //
                    shopDeviceSvcSubNo = Object.assign(shopDeviceSvcSubNo, shopDeviceSvcSubNo.devcMgmtAspkt);
                    shopDeviceSvcSubNo = Object.assign(shopDeviceSvcSubNo, shopDeviceSvcSubNo.devcAssetAspkt);
                    shopDeviceSvcSubNo = Object.assign(shopDeviceSvcSubNo, shopDeviceSvcSubNo.devcMaintAspkt);
                    //
                    shopDeviceSvcSubNo.suitName = suit.name;
                    shopDeviceSvcSubNo.defServicerId = suit.servicerId;
                    shopDeviceSvcSubNo.defServicerName = suit.servicerName;
                    shopDeviceSvcSubNo.ssuId = suit.ssuId;
                    shopDeviceSvcSubNo.servcId = suit.servcId;
                    shopDeviceSvcSubNo.servcTitle = suit.servcTitle;
                    shopDeviceSvcSubNoList.push(shopDeviceSvcSubNo);
                }
                this.handelDeviceList(shopDeviceSvcSubNoList);
            }
        }
    }

</script>
<style>
    .form-value .el-form-item .el-form-item--small {
        margin-bottom: 0;
        margin-top: 4px;
    }
</style>



// WEBPACK FOOTER //
// src/compo/retailer/DeviceMaintPlanAdd.vue